import { action, observable, toJS } from 'mobx'
import BaseStore from '@store/table'
import { message, Modal } from 'hljd'
import Api from '@api/shou_xie/setMeal'

class Store extends BaseStore {
  $listApi = Api.categoryListApi

  @observable
  modal = {
    visible: false,
    id: '',
    title: '',
    weight: '',
    cover_path: ''
  }
  @action
  showModal = (id, title, weight, cover_path = '') => () => {
    Object.assign(this['modal'], {
      visible: true,
      id,
      weight,
      title,
      cover_path
    })
  }
  @action
  cancelModal = param => () => {
    Object.assign(this['modal'], {
      visible: false,
      id: '',
      title: '',
      weight: '',
      cover_path: ''
    })
  }
  @action
  editModal = param => () => {
    Object.assign(this['modal'], {
      visible: false,
      data: '',
      id: '',
      title: param,
      weight: param,
      cover_path: param
    })
  }
  @action
  changeField = (type, index) => e => {
    const { modal } = this
    if (modal.visible) {
      Object.assign(this['modal'], {
        [type]: e.target.value
      })
    } else {
      Object.assign(this.$list[index], {
        [type]: e.target.value
      })
    }
  }
  @action
  addCategory = () => async () => {
    const { modal } = this
    let { success } = await Api.categoryAdd({
      id: modal.id,
      title: modal.title,
      weight: modal.weight,
      cover_path: modal.cover_path
    })
    if (success) {
      Object.assign(this.modal, {
        visible: false,
        id: '',
        title: '',
        weight: '',
        cover_path: ''
      })
      this.$getList()
    }
  }
  @observable weight = ''
  @action
  saveCategory = record => async () => {
    this.weight = record.weight
  }
  @action
  editCategory = (record = {}) => async () => {
    const { modal } = this
    if (this.weight && record && this.weight == record.weight) {
      return
    }
    let { success } = await Api.categoryEdit({
      id: modal.id || record.id,
      title: modal.title || record.title,
      weight: modal.weight || record.weight,
      cover_path: modal.cover_path || record.cover_path || ''
    })
    if (success) {
      Object.assign(this.modal, {
        visible: false,
        id: '',
        title: '',
        weight: '',
        cover_path: ''
      })
      this.$getList()
    }
  }
  //弹框
  @action
  comfirmDel = (id, deleted) => async () => {
    Modal.confirm({
      title: '确认删除分类后，会把分类下的案例置为未设置',
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        this.deletCategory(id, deleted)()
      }
    })
  }
  @action
  deletCategory = (id, deleted) => async () => {
    const { success } = await Api.categoryEdit({
      id,
      deleted
    })
    if (success) {
      this.$getList()
    }
  }
  @action
  isAdd = () => {
    const { modal } = this
    if (!modal.title || modal.title.length <= 0 || modal.title.length > 5) {
      return message.warning('请输入长度不超过5个字的分类名称')
    } else if (!modal.weight || modal.weight === '') {
      return message.warning('分类权重不能为空')
    } else if (modal.id) {
      this.editCategory()()
    } else {
      this.addCategory()()
    }
  }

  @action
  uploaded = (file, link) => {
    this.modal.cover_path = link
  }

  @action
  deleteImage = () => {
    this.modal.cover_path = ''
  }

  @action
  clipPic = ({ clipUrl }) => {
    this.modal.cover_path = clipUrl
  }

  @action
  handleSwitchChange = async (index, res) => {
    let _$list = toJS(this.$list)
    _$list[index].is_show = Number(res)
    this.$list = _$list
    await Api.categoryEdit(_$list[index])
    await this.$getList()
    message.success('操作成功')
  }
}
export default new Store()
